import React, { useEffect, useMemo } from "react";
import { useForm } from "react-hook-form";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import EzControlledDropDowntWithFloatingLabel from "../../../common/EzForm/EzControlledDropDown/WithFloatingLabel";
import { Col, Row } from "react-bootstrap";
import EzControlledInput from "../../../common/EzForm/EzControlledInput";

const CreateCustomerMarkupComponent = ({
  data,
  onClose,
  isOpen,
  title,
  mode = "edit",
  editCustomerMarkups,
  addCustomerMarkup,
  fuelCompanyProviderDD,
  fuelCustomerCompanynNameProviderDD,
}) => {
 
  const defaultFormValues = useMemo(() => {
    return mode === "edit" && data
      ? {
          id: data.id,
          markup_id: data.id || 0,
          customer_id:data?.customer_company_id,
          eob_customer_company_id: data.customer_company_id || 0,
          eob_parent_company_id: data.eob_parent_company_id || 0,
          fuel_company_id:data.fuel_company_provider_id || 0,
          markup_value: data.mark_up_value || 0,
        }
      : {
          id: null,
          customer_id:"",
          eob_customer_company_id: "",
          eob_parent_company_id: "",
          fuel_company_id:"",
          markup_value: "",
        };
  }, [data, mode]);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ defaultValues: defaultFormValues });

  useEffect(() => {
    
    reset(defaultFormValues);
  }, [defaultFormValues, reset]);

  const getDataFilter =(data, value, key) =>{
   let ids= data.filter(item=> item.value===value);
   let valueid= ids[0][key];
   return valueid;
  }
  const onSubmit = (formData) => {
    const basePayload = {
      id: formData.id,
      markupValue: formData.markup_value,
      fuelCompanyProviderId: formData.fuel_company_id,
    };

    if (mode === "edit") {
      editCustomerMarkups({ data: basePayload });
    } else {
      let eob_customer_company_id = getDataFilter(fuelCompanyProviderDD,formData.fuel_company_id, "eob_parent_company_id");
      let eob_parent_company_id = getDataFilter(fuelCustomerCompanynNameProviderDD,formData.customer_id, "customer_id");
      const createPayload = {
        customer_id: eob_parent_company_id,
        eob_customer_company_id: formData.customer_id,
        eob_parent_company_id: eob_customer_company_id,
        fuel_company_id:formData.fuel_company_id,
        markup_value: formData.markup_value,
        "from_date": "",
        "to_date": "",
        "status": "ACTIVE",
      };
       addCustomerMarkup({ data: createPayload });
    }

    onClose();
  };

  const handleClose = () => {
    reset(defaultFormValues);
    onClose();
  };

  return (
    <Dialog
      header={title}
      visible={isOpen}
      onHide={handleClose}
      style={{ width: "45vw" }}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
      
          <Row>
            <Col md={12}>
              <EzControlledDropDowntWithFloatingLabel
                name="customer_id"
                control={control}
                label="Company Name"
                options={fuelCustomerCompanynNameProviderDD}
                optionLabel="label"
                optionValue="value"
                rules={{ required: "Company Name is required" }}
                errorMsg={errors.customer_id?.message}
                isError={!!errors.customer_id}
                disabled={mode=="edit"}
              />
            </Col>
          </Row>
       
        <Row className="rowposition">
          <Col md={12}>
            <EzControlledDropDowntWithFloatingLabel
              name="fuel_company_id"
              control={control}
              label="Fuel Company Provider"
              options={fuelCompanyProviderDD}
              rules={{ required: "Fuel Company Provider is required" }}
              errorMsg={errors.fuel_company_id?.message}
              isError={!!errors.fuel_company_id}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <EzControlledInput
              name="markup_value"
              control={control}
              label="Markup Value"
              type="number"
              rules={{ required: "Markup Value is required", min: 0 }}
              errorMsg={errors.markup_value?.message}
              isError={!!errors.markup_value}
            />
          </Col>
        </Row>

        <div className="d-flex justify-content-end">
          <Button
            type="button"
            label="Cancel"
            className="p-btn-danger p-button-outlined"
            onClick={handleClose}
          />
          <Button
            type="submit"
            label={mode === "edit" ? "Update" : "Create"}
            className="p-button-raised ml-2"
          />
        </div>
      </form>
    </Dialog>
  );
};

export default CreateCustomerMarkupComponent;
